import { Injectable, signal } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd, NavigationExtras } from '@angular/router';
import { filter } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DebugService {

  originalLog: any;
  originalTable: any;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    if (this.state === 'false') {
      console.log('debug logs false for session');
      this.stop();
    }
    (window as any).startDebugLogs = () => this.start();
    (window as any).stopDebugLogs = () => this.stop();
    (window as any).resetDebugLogs = () => this.reset();
    this.router.events.pipe(
      filter((event) => event instanceof NavigationStart),
    ).subscribe(e => {
      if (!this.state) {
        if (environment.showConsoleLogs || (new RegExp('.*\?.*debug')).test(e.url)) {
          console.log(this.start());
        } else if (environment.showConsoleLogs === false) {
          console.log(this.stop());
        }
      } else if (this.state === 'false' && (new RegExp('.*\?.*debug')).test(e.url)) {
        console.warn(this.start() + ' by query param');
      }
    });
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
    ).subscribe(e => {
      if ((new RegExp('.*\?.*debug')).test(e.url)) {
        console.log('remove debug query param');
        const extras: NavigationExtras = {
          relativeTo: this.activatedRoute,
          queryParams: {'debug': null},
          queryParamsHandling: 'merge'
        }
        this.router.navigate([e.url.split('?')[0]], extras);
      }
    });
  }

  get state() {
    return window.sessionStorage.getItem('showConsoleLogs');
  }

  start() {
    this._saveDebugState('true');
    if (this.originalLog) {
      console.log = this.originalLog;
    };
    if (this.originalTable) {
      console.table = this.originalTable;
    }
    return 'debug logging started';
  }

  stop() {
    this._saveDebugState('false');
    this.originalLog = console.log;
    this.originalTable = console.table;
    console.log = () => {
      return;
    }
    console.table = () => {
      return;
    }
    return 'debug logging stopped';
  }

  reset() {
    window.sessionStorage.removeItem('showConsoleLogs');
    return 'debug logging reset';
  }
  
  private _saveDebugState(state: string) {
    window.sessionStorage.setItem('showConsoleLogs', state);
  }
}
